import ProductImagePlaceholder from "../ProductImagePlaceholder";
import StoreBadges from "../StoreBadges";
import ScrollIndicator from "../ScrollIndicator";

export default function HeroSection({
  title,
  subtitle,
  tagline,
  cta,
  onCtaClick,
  variant = "candidat",
  onScrollDown,
  image,
  imageAlt,
}) {
  const isCandidat = variant === "candidat";

  const heroImage = image ? (
    <img
      src={image}
      alt={imageAlt || ""}
      className="w-full h-auto drop-shadow-2xl"
    />
  ) : (
    <ProductImagePlaceholder
      variant={variant}
      label="Capture app — à venir"
      aspectRatio="phone"
    />
  );

  return (
    <div
      className={`min-h-[75vh] lg:min-h-[85vh] flex items-center justify-center px-6 py-20 lg:py-24 relative overflow-hidden bg-gradient-to-br ${
        isCandidat
          ? "from-brand-primary to-brand-accent1"
          : "from-brand-primaryDark to-brand-accent2"
      } text-white`}
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white/30 rounded-full animate-pulse" />
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-white/40 rounded-full animate-bounce" />
        <div className="absolute bottom-1/4 left-1/3 w-3 h-3 bg-white/20 rounded-full animate-pulse" />
      </div>

      <div className="w-full max-w-6xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              {title}
            </h1>

            <div
              className={`mb-6 w-full mx-auto lg:hidden ${
                isCandidat ? "max-w-sm" : "max-w-xs"
              }`}
            >
              {heroImage}
            </div>

            <p className="text-lg sm:text-xl text-white/90 mb-4 max-w-2xl mx-auto lg:mx-0">
              {subtitle}
            </p>
            {tagline && (
              <p className="text-base sm:text-lg text-white/75 mb-8 max-w-xl mx-auto lg:mx-0 italic">
                {tagline}
              </p>
            )}
            {!tagline && <div className="mb-8" />}
            <div className="flex flex-col items-center lg:items-start gap-4">
              <button
                type="button"
                onClick={() => onCtaClick?.("hero")}
                className={`px-8 py-4 rounded-full font-semibold text-lg transition transform hover:scale-105 shadow-xl ${
                  isCandidat
                    ? "bg-white text-brand-primary hover:bg-gray-100"
                    : "bg-white text-brand-primaryDark hover:bg-gray-100"
                }`}
              >
                {cta}
              </button>
              {isCandidat && <StoreBadges />}
            </div>
          </div>

          <div className="hidden lg:block flex-shrink-0 w-full max-w-sm lg:max-w-md">
            {heroImage}
          </div>
        </div>
      </div>

      {onScrollDown && <ScrollIndicator onClick={onScrollDown} />}
    </div>
  );
}
